module.exports = __webpack_public_path__ + "3cabc85988493aa9fced62a1abc8ae4d.MP3";